webpackJsonp([149646851134920],{

/***/ 1696:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusWardEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"CensusWard","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-census-ward-edge-869d04cd0dfe35939a4f.js